<template>
  <div
    class="modal fade"
    id="addSchedule"
    tabindex="-1"
    role="dialog"
    aria-labelledby="#addScheduleLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-lg modal-lgr"
      role="document"
    >
      <form
        class="modal-content"
        @submit="saveSchedule"
      >
        <div class="modal-header row">
          <div class="col col-sm-8">
            <h5
              class="modal-title font-weight-bold"
              id="addScheduleLabel"
            >
              Add Schedule
            </h5>
          </div>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col col-sm-6">
              <h3>Day of Week:</h3>
              <div class="form-group form-row">
                <div class="col col-sm-1 pt-1">
                  <input
                    id="dayAll"
                    type="checkbox"
                    value="selectAll"
                    class="form-control form-control-xxs float-right"
                    :checked="toggleCheckbox"
                    @change="toggleCheckboxes($event, 'nsSelectedDays')"
                  >
                </div>
                <label
                  class="col-sm-8 col-form-label"
                  for="dayAll"
                >
                  Select All
                </label>
              </div>

              <div
                class="form-group form-row"
                v-for="dayOfWeek in daysOfWeek"
                :key="dayOfWeek.day"
              >
                <div class="col col-sm-1 pt-1">
                  <input
                    type="checkbox"
                    class="form-control form-control-xs"
                    :id="'day' + dayOfWeek.day"
                    :value="dayOfWeek.day"
                    v-model="newSchedule.selectedDays"
                    @change="toggleCheckboxes($event, 'nsSelectedDays')"
                  >
                </div>
                <label
                  class="col-sm-8 col-form-label"
                  :for="'day' + dayOfWeek.day"
                >
                  {{ dayOfWeek.name }}
                </label>
              </div>
            </div>

            <div class="col col-sm-6">
              <div class="form-group form-row">
                <label
                  for="timeFrom"
                  class="col col-sm-3 col-form-label font-weight-bolder text-right"
                >
                  Time From:
                </label>
                <div class="col col-sm-9">
                  <input
                    type="time"
                    name="timeFrom"
                    id="timeFrom"
                    required
                    placeholder="TIME FROM"
                    class="form-control form-control-xs"
                    v-model="newSchedule.timeFrom"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <label
                  for="timeFrom"
                  class="col col-sm-3 col-form-label font-weight-bolder text-right"
                >
                  Time To:
                </label>
                <div class="col col-sm-9">
                  <input
                    type="time"
                    name="timeTo"
                    id="timeTo"
                    required
                    placeholder="TIME TO"
                    class="form-control form-control-xs"
                    v-model="newSchedule.timeTo"
                  >
                </div>
              </div>

              <div class="form-group form-row">
                <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
                  STATUS:
                </div>
                <div class="col col-sm-1 pt-1">
                  <input
                    type="checkbox"
                    name="status"
                    id="status"
                    class="form-control form-control-xs"
                    v-model="newSchedule.status"
                  >
                </div>
                <label class="col-sm-3 col-form-label">
                  {{ newSchedule.status | setStatus }}
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="submit"
            class="btn btn-sm btn-outline-primary font-weight-bolder mr-3"
          >
            <span><i class="fas fa-save"/></span>
            SAVE
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import {formMixins} from "../../../../mixins/formMixins";

export default {
  mixins: [formMixins],
  name: "AddTrainingCenterSchedule",
  data() {
    return {
      toggleCheckbox: false,
      nsSelectedDays: [],
      newSchedule: {
        trainingCenterId: this.$route.params.id,
        selectedDays: [],
        timeFrom: '',
        timeTo: '',
        status: false,
      },
      errorTrainingCenterScheduleCreate: {
        selectedDays: '',
        timeFrom: '',
        timeTo: '',
        status: ''
      }
    }
  },
  methods: {
    ...mapActions(['createTrainingCenterSchedule', 'getTrainingCenterSchedules']),
    async saveSchedule(e) {
      e.preventDefault();

      if (await this.confirmCreateAlert('Are you sure you want to add this training center schedule?')) {
        let result = this.createTrainingCenterSchedule(this.newSchedule);
        if (result) {
          this.nsSelectedDays = [];
          this.newSchedule = {
            trainingCenterId: this.$route.params.id,
            selectedDays: [],
            timeFrom: '',
            timeTo: '',
            status: false,
          };
          this.successAlert('New Training Center Schedule Successfully Created', 'CREATE');
          // this.getTrainingCenterSchedules(this.$route.params.id);
        } else {
          this.errorAlert(this.generateErrorMessage(this.errorTrainingCenterScheduleCreate), 'ADD SCHEDULE');
        }
      }
    }
  },
  computed: {
    ...mapGetters(['daysOfWeek'])
  },
  watch: {
    nsSelectedDays: function (value) {
      this.newSchedule.selectedDays = value;
    }
  }
}
</script>

<style scoped>

</style>
